export const APP_VERSION = 'v2.3.260923.909'
